// Frontend/src/contexts/PageHeaderContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';

const PageHeaderContext = createContext();

export const usePageHeader = () => {
  const context = useContext(PageHeaderContext);
  if (!context) {
    throw new Error('usePageHeader must be used within a PageHeaderProvider');
  }
  return context;
};

export const PageHeaderProvider = ({ children }) => {
  const [headerState, setHeaderState] = useState({
    icon: null,
    title: '',
    subtitle: '',
  });

  const setHeader = useCallback(({ icon, title, subtitle }) => {
    setHeaderState({ icon, title, subtitle });
  }, []);

  const clearHeader = useCallback(() => {
    setHeaderState({ icon: null, title: '', subtitle: '' });
  }, []);

  return (
    <PageHeaderContext.Provider value={{ headerState, setHeader, clearHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
};


